<p-tabView>
	<p-tabPanel>
		<ng-template pTemplate="header">
			<fa-icon [icon]="['far', 'bars']" class="me-4" size="lg"></fa-icon>
			Menu
		</ng-template>
		<app-menu-setup></app-menu-setup>
	</p-tabPanel>
	<p-tabPanel>
		<ng-template pTemplate="header">
			<fa-icon [icon]="['far', 'file-chart-pie']" class="me-4" size="lg"></fa-icon>
			Reports
		</ng-template>
		<app-report-setup></app-report-setup>
	</p-tabPanel>
	<p-tabPanel>
		<ng-template pTemplate="header">
			<fa-icon [icon]="['far', 'table']"></fa-icon>
			Table Setup
		</ng-template>
		<app-table-data-model-list></app-table-data-model-list>
	</p-tabPanel>
</p-tabView>
